// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__qmyCJ","table":"Table_table__V4ktR","more":"Table_more__gFNJT"};